import { InjectionToken } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export const IS_AUTH_TOKEN = new InjectionToken<BehaviorSubject<boolean>>('Is auth token', {
  providedIn: 'root',
  factory: () => new BehaviorSubject<boolean>(false),
});
